import React from "react";

import { DonutChart } from "../charts/DonutChart";
import { ChartLayout, layoutHeight, layoutWidth } from "../charts/chartTheme";
import { Language } from "../Language";

interface IEsgShareProps {
    data: any;
    locale?: Language;
    showHeader: boolean;
    style?: React.CSSProperties | undefined;
    layout?: ChartLayout;
}

export const EsgShare = ({ data, showHeader, locale = Language.Sv, layout, style }: IEsgShareProps): React.ReactElement => {
    let header: string = null;
    let explanation: string = null;
    if (locale === Language.En) {
        header = "Sustainability";
        explanation = "The diagram shows the portion of the fund that passes or does not pass Captor's standard screening.";
    } else if (locale === Language.Sv) {
        header = "Hållbarhet";
        explanation = "Diagrammet visar hur stor del av fonden som klarar eller inte klarar Captors standardscreening.";
    }
    const slices = (data?.data?.esgScreenings ?? []).map((row) => ({ label: String(row.esgScreening), value: Number(row.value) }));

    return (
        <React.Fragment>
            {showHeader !== false ? <h3>{header}</h3> : null}
            <DonutChart
                slices={slices}
                colors={layout?.colorway ?? ["#43a04c", "#307e41", "#1F5F32", "#bdbdbd"]}
                hole={0.4}
                showLegend={layout?.showlegend ?? false}
                labelMode="label+percent"
                ariaLabel={header || "Sustainability"}
                height={layoutHeight(layout, 320)}
                width={layoutWidth(layout)}
                style={style}
            />
            <small>{explanation}</small>
        </React.Fragment>
    );
};
